import styled, { x } from '@xstyled/styled-components';
import React from 'react';
import { t } from 'ttag';
import { Card } from '../card/Card';
import { Flex } from '../flex/Flex';
import Background from './background.file.svg';
import Llama from '~/assets/llamas/llama-right.svg';
import PointerImg from './bubble-pointer.svg';

const Pointer = styled(PointerImg)`
  position: absolute;
  height: 30px;
  top: 140px;
  left: -27px;
  transform: rotate(90deg);
`;

export const OldBrowsers = () => {
  return (
    <x.div
      backgroundColor="yellowLight"
      backgroundImage={`url(${Background})`}
      backgroundPosition="bottom"
      backgroundSize="contain"
      backgroundRepeat="no-repeat"
      w="100%"
      h="100%"
      display="flex"
      alignItems="flex-end"
      justifyContent="center"
      gap="xxl"
    >
      <Llama />
      <div>
        <Card marginTop="-400px">
          <Pointer />
          <Flex variant="list" gap="md">
            <x.h1 fontFamily="llama">{t`Hey buddy!`}</x.h1>
            <p>{t`We highly recommend switching to another browser such as Chrome, Firefox or Edge`}</p>
          </Flex>
        </Card>
      </div>
    </x.div>
  );
};
